<div class="denounce-detail-local modal-wrapper" style="background: #fffbff">
  <div id="step01" *ngIf="!successStep">
    <form [formGroup]="newUserForm" class="local-edit-form modal__form">
      <header class="denounce-detail-data-header modal__header">
        <div
          style="
            display: flex;
            width: 100%;
            max-width: 380px;
            margin: 0 auto;
            align-items: center;
            gap: 30px;
          "
        >
          <img src="assets/icons/peopleWithBg.svg" alt="" />

          <h2 *ngIf="!user" class="modal__title">
            {{ "UserManagementNewUser" | translate }}
          </h2>
          <h2 *ngIf="user" class="modal__title">
            {{ "UserManagementEditUser" | translate }}
          </h2>
        </div>
      </header>
      <div class="modal__body">
        <div class="denounce-detail-content local">
          <div
            *ngIf="showAlert"
            [@animationAlert]
            class="alert alert-danger alert-dismissible fade"
            [ngClass]="{ show: showAlert, hide: !showAlert }"
            role="alert"
          >
            <div
              class="d-flex align-items-center"
              dangerouslySetInnerHtml="'UserManagementEmailRegisteredText | translate"
            ></div>
            <button
              type="button"
              class="close"
              data-dismiss="alert"
              aria-label="Close"
              (click)="closeAlert()"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="form-group">
            <label
              class="form__label"
              for="name"
              dangerouslySetInnerHtml="'UserManagementFullNameLabel' | translate"
            ></label>
            <input
              id="name"
              type="text"
              [class.is-invalid]="
                newUserForm.get('name').invalid &&
                newUserForm.get('name').touched
              "
              class="login-form-input form-control"
              required
              [placeholder]="'UserManagementInsertPlaceholder' | translate"
              name="name"
              formControlName="name"
            />
            <div
              *ngIf="
                (newUserForm.get('name').invalid &&
                  newUserForm.get('name').touched) ||
                newUserForm.get('name').dirty
              "
              class="message-wrapper"
            >
              <span
                *ngIf="newUserForm.get('name').errors?.required"
                class="text-danger"
              >
                {{ "UserManagementNameRequired" | translate }}
              </span>
            </div>
          </div>

          <div class="form-group" *ngIf="!user && superUser">
            <label
              class="form__label"
              for="name"
              dangerouslySetInnerHtml="'UserManagementOrganizationLabel' | translate"
            ></label>
            <input
              id="organization"
              type="text"
              [class.is-invalid]="
                newUserForm.get('organization').invalid &&
                newUserForm.get('organization').touched
              "
              class="login-form-input form-control"
              required
              [placeholder]="'UserManagementInsertPlaceholder' | translate"
              name="organization"
              formControlName="organization"
            />
            <div
              *ngIf="
                (newUserForm.get('organization').invalid &&
                  newUserForm.get('organization').touched) ||
                newUserForm.get('organization').dirty
              "
              class="message-wrapper"
            >
              <span
                *ngIf="newUserForm.get('organization').errors?.required"
                class="text-danger"
              >
                {{ "UserManagementOrganizationRequired" | translate }}
              </span>
            </div>
          </div>
          <div class="form-group">
            <label
              class="form__label"
              for="email"
              dangerouslySetInnerHtml="'UserManagementEmailLabel' | translate"
            ></label>
            <input
              id="email"
              emailValidation
              type="email"
              [class.is-invalid]="
                newUserForm.get('email').invalid &&
                newUserForm.get('email').touched
              "
              required
              class="login-form-input form-control"
              [placeholder]="'UserManagementInsertPlaceholder' | translate"
              name="email"
              formControlName="email"
            />
            <div
              *ngIf="
                (newUserForm.get('email').invalid &&
                  newUserForm.get('email').touched) ||
                newUserForm.get('email').dirty
              "
              class="message-wrapper"
            >
              <span
                *ngIf="newUserForm.get('email').errors?.required"
                class="text-danger"
              >
                {{ "UserManagementEmailRequired" | translate }}
              </span>
              <span
                *ngIf="newUserForm.get('email').errors?.email"
                class="text-danger"
              >
                {{ "UserManagementEmailInvalid" | translate }}
              </span>
              <span
                *ngIf="newUserForm.get('email').errors?.uniqueEmail"
                class="text-danger"
              >
                {{ "UserManagementEmailUnique" | translate }}
              </span>
            </div>
          </div>
          <div *ngIf="!superUser" class="form-group">
            <label
              class="form__label"
              for="func"
              dangerouslySetInnerHtml="'UserManagementRoleLabel' | translate"
            ></label>
            <div class="select__wrapper">
              <select
                [class.is-invalid]="
                  newUserForm.get('func').invalid &&
                  newUserForm.get('func').touched
                "
                class="form-control"
                required
                formControlName="func"
                id="user-func"
              >
                <option value="" selected disabled>
                  {{ "UserManagementRoleChooseRole" | translate }}
                </option>
                <option value="ADMIN">
                  {{ "UserManagementRoleAdmin" | translate }}
                </option>
                <option value="OP">
                  {{ "UserManagementRoleOp" | translate }}
                </option>
              </select>
            </div>
            <div
              *ngIf="
                (newUserForm.get('func').invalid &&
                  newUserForm.get('func').touched) ||
                newUserForm.get('func').dirty
              "
              class="message-wrapper"
            >
              <span
                *ngIf="newUserForm.get('func').errors?.required"
                class="text-danger"
              >
                {{ "UserManagementRoleRequired" | translate }}
              </span>
            </div>
          </div>
          <div class="form-group" *ngIf="superUser">
            <label
              class="form__label"
              for="locale"
              dangerouslySetInnerHtml="'UserManagementLocaleLabel' | translate"
            >
            </label>
            <div class="select__wrapper">
              <select
                id="cidade-user"
                [class.is-invalid]="
                  newUserForm.get('locale').invalid &&
                  newUserForm.get('locale').touched
                "
                class="form-control"
                required
                formControlName="locale"
              >
                <option value="" selected disabled>
                  {{ "UserManagementLocaleChooseLocale" | translate }}
                </option>
                <option [value]="city.admin_id" *ngFor="let city of cities">
                  {{ city.name }}
                </option>
              </select>
            </div>
            <div
              *ngIf="
                (newUserForm.get('locale').invalid &&
                  newUserForm.get('locale').touched) ||
                newUserForm.get('locale').dirty
              "
              class="message-wrapper"
            >
              <span
                *ngIf="newUserForm.get('locale').errors?.required"
                class="text-danger"
              >
                {{ "UserManagementLocaleRequired" | translate }}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="container-buttons">
        <button
          id="btn-cancel-update"
          mat-button
          (click)="onClose()"
          style="
            color: var(--material-theme-sys-light-primary, #5b43d9);
            text-align: center;
            font-family: Roboto;
            font-size: 16px;
            font-style: normal;
            font-weight: 500;
            line-height: 24px;
            max-height: 30px;
            border-radius: 0px;
            border-bottom: 1px solid #5b43d9;
          "
        >
          {{ "UserManagementeCancel" | translate }}
        </button>
        <button
          style="
            display: inline-flex;
            height: 40px;
            padding: 24px 24px;
            justify-content: center;
            align-items: center;
            gap: 8px;
            border-radius: 40px;
            text-align: center;
            font-family: Roboto;
            font-size: 16px;
            font-style: normal;
            font-weight: 500;
            line-height: 24px;
          "
          class="confirm-update-user"
          *ngIf="user"
          mat-stroked-button
          [disabled]="!newUserForm.valid"
          (click)="newUser()"
        >
          <span>
            {{ "UserManagementUpdate" | translate }}
          </span>
        </button>
        <button
          style="
            display: inline-flex;
            height: 40px;
            padding: 24px 24px;
            justify-content: center;
            align-items: center;
            gap: 8px;
            border-radius: 40px;
            text-align: center;
            font-family: Roboto;
            font-size: 16px;
            font-style: normal;
            font-weight: 500;
            line-height: 24px;
            flex-shrink: 0;
          "
          class="confirm-update-user"
          *ngIf="!user"
          mat-stroked-button
          (click)="newUser()"
          [disabled]="!newUserForm.valid"
        >
          <span style="padding-right: 2px" class="material-icons">add</span>
          {{ "UserManagementAdd" | translate }}
        </button>
      </div>
    </form>
  </div>
  <div
    id="step02"
    *ngIf="successStep"
    class="modal-message modal-message--success"
  >
    <mat-icon
      aria-hidden="false"
      aria-label="Check Circle Outline Icon"
      class="modal-message__icon"
    >
      check_circle_outline</mat-icon
    >
    <h2 class="modal-message__title">
      {{ "UserManagementUserAdded" | translate }}
    </h2>
    <p
      class="modal-message__text"
      dangerouslySetInnerHtml="'UserManagementUserAddedEmailSent' | translate"
    ></p>
    <button mat-stroked-button (click)="redirectTo('/home/manage-users')">
      {{ "UserManagementFinished" | translate }}
    </button>
    <button mat-button (click)="goToAddUser()">
      {{ "UserManagementAddAnotherUser" | translate }}
    </button>
  </div>
</div>
